/*
 * app.tsx
 *
 * @Author: xiaoJQ
 * @Date: 2024-06-07 17:32:31
 *
 * Copyright © 2024 kingdee.com. All Rights Reserved.
 */
import React, { useMemo } from 'react';
import HomePage from 'components/homePage';
import DisplayPage from 'components/displayPage';
import { useSelector } from 'store/hook/useSelector';
import 'antd/dist/antd.css';
import '@kdcloudjs/kdesign/dist/kdesign.css';
import S from './index.less';
var App = function () {
    var activeView = useSelector(function (state) { return state.control.activeView; });
    var renderIndex = useMemo(function () {
        switch (activeView) {
            case 'homepage':
                return function () { return React.createElement(HomePage, null); };
            case 'displaypage':
                return function () { return React.createElement(DisplayPage, null); };
            default:
                return function () { return null; };
        }
    }, [activeView]);
    return (React.createElement("div", { className: S.tie }, renderIndex()));
};
export default App;
